export enum AutoAssignWorkOrderTemplateStatus {
  Queued = "Queued",
  InProgress = "InProgress",
  Completed = "Completed",
  Failed = "Failed",
}
